<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-container fluid grid-list-md>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-md>
                    <v-layout row wrap>
                      <v-flex lg4 xs6>
                        <v-text-field v-model="filters.insdRefNo" :label="filtersLabel.insdRefNo" :error-messages="errors.collect('insdRefNo')" data-vv-name="insdRefNo" :data-vv-as="filtersLabel.insdRefNo" v-validate="'entry|max:8'"></v-text-field>
                      </v-flex>
                      <v-flex lg4 xs6>
                        <v-text-field v-model="filters.fullName" :label="filtersLabel.fullName" :error-messages="errors.collect('fullName')" data-vv-name="fullName" :data-vv-as="filtersLabel.fullName" v-validate="'name|max:300'"></v-text-field>
                      </v-flex>
                      <v-flex lg4 xs6>
                        <v-autocomplete :items="clientGrpList" v-model="filters.clientGrp" column :label="filtersLabel.clientGrp" item-text="label" item-value="value" :error-messages="errors.collect('clientGrp')" data-vv-name="clientGrp" :data-vv-as="filtersLabel.clientGrp"></v-autocomplete>
                      </v-flex>
                      <v-flex lg4 xs6>
                        <v-autocomplete :items="clientTypeList" v-model="filters.clientType" :label="filtersLabel.clientType" item-text="label" item-value="value" data-vv-name="clientTypeList" :data-vv-as="filtersLabel.clientType" :error-messages="errors.collect('clientTypeList')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex lg4 xs6>
                        <v-autocomplete :items="blackListList" v-model="filters.blackList" column :label="filtersLabel.blackList" item-text="label" item-value="value" :error-messages="errors.collect('blackList')" data-vv-name="blackList" :data-vv-as="filtersLabel.blackList"></v-autocomplete>
                      </v-flex>
                      <v-flex lg4 xs6>
                        <v-autocomplete :items="inactiveList" v-model="filters.inactive" column :label="filtersLabel.inactive" item-text="label" item-value="value" :error-messages="errors.collect('inactive')" data-vv-name="inactive" :data-vv-as="filtersLabel.inactive"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <message :messages="messages"></message>
      <v-layout row wrap>
        <v-flex xs12 class="mt-1">
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="doNew" v-if="checkAccess([permissionKeys.perm_050115])">
                New Insured
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </v-card-title>
            <!-- <v-data-table v-bind:headers="headers" v-bind:items="items" :server-items-length="totalItems" :footer-props="{'items-per-page-options': itemsPerPage }" v-bind:options.sync="pagination" item-key="insdRefNo" :loading="loading" :no-data-text="noDataText">
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span v-on="on">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template v-slot:item="row">
                <td>{{ row.item.insdRefNo }}</td>
                <td class="text-xs-left">{{ row.item.fullName }}</td>
                <td class="text-xs-left">{{ formatClientGrp(row.item.clientGrp) }}</td>
                <td class="text-xs-left">{{ row.item.clientTypeDesc }}</td>
                <td class="text-xs-left">{{ row.item.telNo1}}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query review @review="doReview" @query="doQuery" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </template>
            </v-data-table> -->
            <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :loading="loading"
            :no-data-text="noDataText"
            :server-items-length="totalItems"
            item-key="insdRefNo"
            v-bind:options.sync="pagination"
            >
            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.insdRefNo }}</td>
                <td class="text-xs-left">{{ row.item.fullName }}</td>
                <td class="text-xs-left">{{ formatClientGrp(row.item.clientGrp) }}</td>
                <td class="text-xs-left">{{ row.item.clientTypeDesc }}</td>
                <td class="text-xs-left">{{ row.item.telNo1}}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    :query="checkAccess([permissionKeys.perm_050130])"
                    @query="doQuery"
                    :review="checkAccess([permissionKeys.perm_050125])"
                    @review="doReview"
                    :remove="checkAccess([permissionKeys.perm_050120])"
                    @remove="doPromptRemove(row.item)"
                    >
                  </table-action>
                </td>
              </tr>
            </template>
            </v-data-table>
          </v-card>
          <confirm v-model="promptRemove" @ok="doRemove">
            Are you sure that you want to delete the selected Insured? ({{deleteInsured}})
          </confirm>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import clone from 'clone'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime2, formatDisplayDate } from '@/utils/date'
import { permissionKeys } from '@/mixins/global/permissionKey'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Client Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'clientType' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Insured Reference', value: 'insdRefNo' },
        { text: 'Name', value: 'fullName' },
        { text: 'Group', value: 'clientGrp' },
        { text: 'Type', value: 'clientType' },
        { text: 'Telephone No.', value: 'telNo1' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        insdRefNo: null,
        fullName: null,
        clientGrp: null,
        clientType: null,
        blackList: null,
        inactive: null
      },
      filtersLabel: {
        insdRefNo: 'Insured Reference',
        fullName: 'Insured Name',
        clientGrp: 'Insured Group',
        clientType: 'Insured Type',
        blackList: 'Blacklisted',
        inactive: 'Inactive'
      },
      blackListList: [
        { label: 'All', value: null },
        { label: 'Blacklisted', value: true },
        { label: 'Not Blacklisted', value: false }
      ],
      inactiveList: [
        { label: 'All', value: null },
        { label: 'Active', value: true },
        { label: 'Inactive', value: false }
      ],
      clientGrpList: [
        { label: 'Individual', value: 'I' },
        { label: 'Corporation', value: 'C' }
      ],
      clientTypeList: [],
      promptRemove: false,
      selectedInsured: undefined,
      deleteInsured: '',
      permissionKeys: permissionKeys,
      pagination: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    adminInsuredInit() {
      return this.$store.state.adminInsured
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      await Promise.all([this.$store.dispatch('insuredsManagementInit')])
      if (this.adminInsuredInit.init === 1) {
        this.doFetchData(options)
        Promise.all([this.getClientTypeList()])
      }
    },
    doFetchData() {
      if (this.adminInsuredInit.init === 1) {
        this.fetchData(true)
      }
    },
    async fetchData(options) {
      const apiUrl = this.$store.state.adminInsured.menu.InsuredsList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)

          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((insured) => {
                const convertInsured = {
                  insdRefNo: insured.insdRefNo,
                  fullName: insured.fullName.replace('null', ''),
                  clientGrp: insured.clientGrp,
                  clientType: insured.clientType,
                  clientTypeDesc: insured.clientTypeDesc,
                  telNo1: insured.telNo1
                }
                this.items.push(convertInsured)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.filters.insdRefNo = null
      this.filters.fullName = null
      this.filters.clientType = null
      this.filters.clientGrp = null
      this.filters.clientTypeList = null
      this.filters.blackList = null
      this.filters.inactive = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doQuery(data) {
      if (data && data.item && data.item.insdRefNo) {
        this.$router.push({ name: 'queryDetails', params: { insdRefNo: data.item.insdRefNo, clientType: data.item.clientType } })
      }
    },
    doReview(data) {
      if (data && data.item && data.item.insdRefNo) {
        this.$router.push({ name: 'reviewDetails', params: { insdRefNo: data.item.insdRefNo, clientType: data.item.clientType } })
      }
    },
    doNew() {
      this.$router.push({ name: 'reviewDetails', params: { insdRefNo: 'new', clientType: 'new' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedInsured = data
        this.deleteInsured = data.insdRefNo
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.adminInsured.menu.deleteInsured
      if (apiURI) {
        const expand = this.selectedInsured
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.fetchData(true)
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    },
    formatClientGrp(clientGrp) {
      if (clientGrp === 'I') {
        return 'Individual'
      } else if (clientGrp === 'C') {
        return 'Corporation'
      }
    },
    async getClientTypeList() {
      const apiURI = this.$store.state.adminInsured.menu.clientTypeList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.clientTypeList = data.data
        }
      } catch (err) {
        throw err
      }
    }
  },
  mounted() {
    this.doInit(true)
  },
  components: {
    SideFunctionMenu
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
